import React, { useCallback, useEffect, useState } from 'react';
import { Card, Dropdown, Table, Typography } from 'antd';
import styles from './index.module.less';
import { fetchInsRecentSearchHistory, fetchUnfollowTrackingList, fetchFollowBackList } from '@/lib/service';
import { useUserProvider } from '@/context/UserProvider';
import { debounce } from 'lodash-es';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { useRouter } from 'next/router';
import SettingsEmptyContent from '../SettingsEmpty';
import classNames from 'classnames';
import { DownOutlined } from '@ant-design/icons';
import ResultsArea from './ResultsArea';
import { FollowBackModel, UnfollowTrackingModel } from '@/types/unFollow';

const { Title } = Typography;

const ResultsContent: React.FC = () => {
  const { isLogin } = useUserProvider();
  const [list, setList] = useState<any[]>([]);
  const { t } = useTranslation();
  const router = useRouter();

  const columns = [
    {
      title: t('Target Account'),
      dataIndex: 'targetAccount',
      key: 'targetAccount',
    },
    {
      title: t('Date'),
      dataIndex: 'date',
      key: 'date',
    },
    {
      title: t('Type'),
      dataIndex: 'type',
      key: 'type',
    },
  ];

  const loadData = useCallback(
    debounce(async () => {
      const listRes = await fetchInsRecentSearchHistory();

      const tempList = listRes?.data?.map((item, index) => ({
        key: item?.happen_date + `${index}`,
        targetAccount: item?.media_name,
        date: item?.happen_date,
        type: item?.type,
      }));
      setList(tempList);
    }, 300),
    []
  );

  useEffect(() => {
    loadData();
  }, [isLogin]);

  useEffect(() => {
    loadData();
  }, []);

  const titleList = [
    {
      type: 'ins',
      title: t('Instagram Activity Monitoring'),
      icon: '/images/settings/ins-icon.webp',
      path: '/dashboard',
    },
    {
      type: 'recent',
      title: t('Instagram Recent Follower Tracker'),
      icon: '/images/settings/recent-follow-icon.webp',
    },
    {
      type: 'unfollow',
      title: t('Instagram Unfollower Tracker'),
      icon: '/images/settings/unfollow.webp',
    },
  ];
  const [currentType, setCurrentType] = useState(titleList[1]);

  const [unfollowTrackList, setUnfollowTrackList] = useState<UnfollowTrackingModel[]>([]);
  const [unfollowBackList, setUnfollowBackList] = useState<FollowBackModel[]>([]);
  useEffect(() => {
    if (currentType?.type === 'unfollow') {
      fetchFollowBackList().then((res) => {
        setUnfollowBackList(res?.data);
      });
      fetchUnfollowTrackingList().then((res) => {
        setUnfollowTrackList(res?.data);
      });
    }
  }, [currentType]);

  const items = titleList?.map((item) => {
    return {
      key: item?.type,
      label: (
        <div
          key={item.type}
          className={classNames([styles.filter])}
          onClick={() => {
            if (item?.path) {
              router.push(item?.path);
            }
          }}
        >
          <Image src={item?.icon} alt={''} width={22} height={22} />
          <span>{item?.title}</span>
        </div>
      ),
    };
  });

  return (
    <div className={styles.container}>
      <div className={styles.filters}>
        {titleList?.map((item) => {
          return (
            <div
              key={item.type}
              className={classNames([styles.filter, item.type === currentType.type && styles.filterSelect])}
              onClick={() => {
                if (item?.path) {
                  router.push(item?.path);
                } else {
                  setCurrentType(item);
                }
              }}
            >
              <Image src={item?.icon} alt={''} width={22} height={22} />
              <span>{item?.title}</span>
            </div>
          );
        })}
      </div>

      <div className={styles.phoneFilters}>
        <Dropdown menu={{ items }}>
          <div className={classNames([styles.filter])} style={{ justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Image src={currentType?.icon} alt={''} width={22} height={22} />
              <span>{currentType?.title}</span>
            </div>
            <DownOutlined />
          </div>
        </Dropdown>
      </div>

      {currentType?.type === 'recent' && (
        <Card className={styles.card}>
          <div className={styles.usageHistory}>
            <Title level={2} className={styles.historyTitle}>
              {t('Activity Log')}
            </Title>
            {list?.length > 0 ? (
              <Table
                columns={columns}
                dataSource={list}
                pagination={{
                  position: ['bottomCenter'],
                }}
              />
            ) : (
              <SettingsEmptyContent
                title={t('No Activity Found')}
                desction={t(
                  "It looks like there are no search results yet. Want to see someone’s Instagram follow activity?<br> <a href='/instagram-new-follow-tracker' style='color:#725CFF;fontWeight:600'>Start tracking now!</a>"
                )}
              />
            )}
          </div>
        </Card>
      )}
      {currentType?.type === 'unfollow' && (
        <div className={styles.unfollow}>
          <ResultsArea unfollowBackList={unfollowBackList} unfollowTrackList={unfollowTrackList} />
        </div>
      )}
    </div>
  );
};

export default ResultsContent;
